import { useState, useEffect } from 'react';
import { getSettings } from '../services/api';
import { companyInfo as mockInfo } from '../data/mock';

/**
 * Converte um link normal do YouTube para o formato de incorporação (embed)
 */
const getEmbedUrl = (url) => {
    if (!url) return '';
    if (url.includes('youtube.com/embed/')) return url;

    // Suporta youtu.be/ID, youtube.com/watch?v=ID, youtube.com/v/ID, etc.
    const videoIdMatch = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|v\/|embed\/|shorts\/))([^#&?]*)/);
    if (videoIdMatch && videoIdMatch[1]) {
        return `https://www.youtube.com/embed/${videoIdMatch[1]}`;
    }
    return url;
};

/**
 * Hook to manage global site settings from Google Sheets CMS
 */
export const useSettings = () => {
    // Create initial state with whatsappPhone already calculated
    const initialWhatsappPhone = mockInfo.phone.replace(/\D/g, '');
    const [settings, setSettings] = useState({
        ...mockInfo,
        whatsappPhone: initialWhatsappPhone
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSettings = async () => {
            const result = await getSettings();
            if (result.success && Object.keys(result.config).length > 0) {
                const rawPhone = result.config.phone || mockInfo.phone;
                // Remove tudo que não for dígito para o link do WhatsApp (ex: +351 937... -> 351937...)
                const whatsappPhone = rawPhone.replace(/\D/g, '');

                setSettings({
                    ...mockInfo,
                    phone: rawPhone,
                    whatsappPhone: whatsappPhone,
                    email: result.config.email || mockInfo.email,
                    videoUrl: getEmbedUrl(result.config.videoUrl || mockInfo.videoUrl),
                    facebookUrl: result.config.facebookUrl || mockInfo.facebookUrl,
                    instagramUrl: result.config.instagramUrl || mockInfo.instagramUrl
                });
            }
            setLoading(false);
        };

        fetchSettings();
    }, []);

    return { settings, loading };
};
